import SocialMedia from "../SocialMedia";
import "../Css/DesktopNavigation.css";
import { motion } from "framer-motion";
export default function DesktopNavigation() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
        duration: 2,
      },
    },
  };
  const item = {
    hidden: { x: "-100vw" },
    show: {
      x: 0,
      transition: {
        stiffness: 60,
        type: "spring",
      },
    },
  };

  return (
    <div className="DesktopNavigation-container">
      <motion.nav variants={container} animate="show" initial="hidden">
        <motion.a href="#about">عني</motion.a>
        <motion.a href="#journey">رحلتي</motion.a>
        <motion.a href="#recordings">تسجيبلاتي</motion.a>
        <motion.a href="#">تواصل معي</motion.a>
      </motion.nav>

      <SocialMedia container={container} item={item} />
    </div>
  );
}
